<template>
    <div
        class="container"
        v-loading.fullscreen.lock="loading"
        element-loading-background="rgba(255, 255, 255, 0.3)"
    >
        <div class="text table-wrap">
            <el-dialog
                :visible.sync="isSignFormShow"
                width="35%"
                append-to-body
            >
                <el-form
                    label-position="left"
                    label-width="90px"
                    ref="form"
                    :model="form"
                    size="medium"
                >
                    <el-form-item label="Email">
                        <el-input v-model="form.email"></el-input>
                    </el-form-item>
                    <el-form-item label="Password">
                        <el-input
                            v-model="form.password"
                            show-password
                        ></el-input>
                    </el-form-item>
                    <div
                        style="text-align: center; margin: 30px 0 0 0; display: inline;"
                    >
                        <el-form-item>
                            <el-button
                                type="primary"
                                @click="submitForm('form')"
                                >Sign In</el-button
                            >
                        </el-form-item>
                    </div>
                </el-form>
            </el-dialog>
            <div v-if="!isSignFormShow">
                <div class="bg-white">
                    <el-row type="flex" align="middle" class="pt-10 pr-10">
                        <el-col :span="4" class="label">
                            Sender Name
                        </el-col>
                        <el-col :span="18" class="text-description">
                            {{sender}}
                        </el-col>
                    </el-row>
                    <el-row type="flex" align="middle" class="pt-10 pr-10" >
                        <el-col :span="4" class="label">
                            Api key
                        </el-col>
                        <el-col :span="18" class="text-description">
                          {{apiKey}}
                        </el-col>
                    </el-row>
                    <el-row type="flex" align="middle" class="pt-10 pr-10">
                        <el-col :span="4" class="label">
                            Message
                        </el-col>
                        <el-col :span="20">
                            <el-input
                                type="textarea"
                                :autosize="{ minRows: 3,maxRows:10}"
                                placeholder="Please enter the message"
                                v-model="message"
                                :disabled="!sender"
                            >
                            </el-input>
                        </el-col>
                    </el-row>
                    <el-row
                        type="flex"
                        justify="start"
                        class="personal"
                        align="middle"
                    >
                        <el-col :span="8">
                            <el-checkbox
                                v-model="isPersonalMessage"
                                label="Do you want to send personal message?"
                                class="label"
                            ></el-checkbox>
                        </el-col>
                        <el-col :span="14" :offset="2" v-if="isPersonalMessage">
                            <el-row type="flex">
                                <el-col :span="18">
                                    <el-input
                                        v-model="recipientEmail"
                                        placeholder="Recipient email"
                                        type="email"
                                    />
                                </el-col>
                                <el-col :span="4" :offset="2">
                                    <el-button
                                        size="primary"
                                        @click="sendPersonalMessage()"
                                        icon="el-icon-s-promotion"
                                        :disabled="
                                            !(
                                                recipientEmail &&
                                                message &&
                                                sender
                                            )
                                        "
                                        >Send</el-button
                                    >
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </div>
                <el-table
                    :data="searchData(rooms, search)"
                    max-height="80vh"
                    row-key="_id"
                    :border="true"
                    default-expand-all
                    :tree-props="{ children: 'breakoutRooms' }"
                >
                    <el-table-column
                        prop="name"
                        label="Name"
                        :sortable="false"
                        width="180"
                    >
                    </el-table-column>
                    <el-table-column align="right">
                        <!-- eslint-disable-next-line vue/no-unused-vars -->
                        <template slot="header" slot-scope="scope">
                            <el-row type="flex">
                                <el-col>
                                    <el-input
                                        v-model="search"
                                        placeholder="Type to search rooms"
                                    />
                                </el-col>
                            </el-row>
                        </template>
                        <template slot-scope="scope">
                            <el-button
                                size="primary"
                                @click="sendToThisRoom(scope.$index, scope.row)"
                                icon="el-icon-s-promotion"
                                :disabled="!(message && sender)"
                                >Send</el-button
                            >

                            <el-button
                                type="secondary"
                                :disabled="!(message && sender)"
                                @click="
                                    sendToAllAssociatedRoom(
                                        scope.$index,
                                        scope.row
                                    )
                                "
                                v-if="!scope.row.parent"
                            >
                                <icon
                                    class="broadcast-message"
                                    name="bullhorn"
                                ></icon>
                                <span class="pl-5">Send to All Rooms</span>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from '../client';
import Icon from 'vue-awesome/components/Icon';

export default {
    name: 'ThirdPartyDashboard',
    components: {
        Icon,
    },
    data: function() {
        return {
            rooms: [],
            search: '',
            message: '',
            sender: '',
            isPersonalMessage: false,
            recipientEmail: '',
            loading: false,
            apiKey: this.getApiKey(),
            isSignFormShow: !this.getApiKey(),
            form: {
                email: '',
                password: '',
            },
        };
    },
    watch: {
        async isSignFormShow(newVal) {
            if (newVal == false) {
                await this.getDashboardData();
            }
        },
    },
    mounted: async function() {
        if (!this.isSignFormShow && this.apiKey) {
            await this.getDashboardData();
        } else {
            this.isSignFormShow = true;
        }
    },
    methods: {
        async sendToAllAssociatedRoom(index, row) {
            const data = {
                message: this.message,
                eventType: 'BROADCAST_TO_MAIN_ROOM',
                roomId: row._id,
            };
            await this.makeRequest(data);
        },
        async sendToThisRoom(index, row) {
            const data = {
                message: this.message,
                eventType: 'BROADCAST_TO_SPECIFIC_ROOM',
                roomId: row._id,
            };
            await this.makeRequest(data);
        },
        searchData(rooms, search) {
            if (!search) return rooms;
            return rooms.filter((room) => {
                return (
                    room.name.toLowerCase().includes(search.toLowerCase()) ||
                    room.breakoutRooms.filter((r) =>
                        r.name.toLowerCase().includes(search.toLowerCase())
                    ).length
                );
            });
        },
        async sendPersonalMessage() {
            const data = {
                message: this.message,
                eventType: 'SPECIFIC_MESSAGE',
                targetUser: this.recipientEmail,
            };
            await this.makeRequest(data);
        },
        async makeRequest(data) {
            this.loading = true;
            const response = await axios.post('api/external/send', data, {
                headers: {
                    'x-api-key': this.apiKey,
                },
            });
            this.loading = false;
            return response.data;
        },
        getApiKey() {
            return localStorage.getItem('apiKey');
        },
        async getDashboardData() {
            const response = await axios.get('/api/external/dashboard', {
                headers: {
                    'x-api-key': this.apiKey,
                },
            });
            const data = response.data;
            this.sender = data.firstName + ' ' + (data.lastName || ' ');
            this.rooms = data.rooms;
        },
        async submitForm() {
            if (!(this.form.email && this.form.password)) {
                alert("username and password both are mandatory.");
            } else {
                const data = {
                    email: this.form.email.toLowerCase(),
                    password: this.form.password,
                };
                const apiResponse = await axios.post(
                    'api/external/signin',
                    data
                );
                const response = apiResponse.data;
                if (response.apiKeys && response.apiKeys.length) {
                    this.apiKey = response.apiKeys[0];
                    localStorage.setItem('apiKey', this.apiKey);
                    this.isSignFormShow = false;
                }
            }
        },
    },
};
</script>

<style scoped>
.table-wrap {
    width: 90%;
    margin: 20px auto;
}
.container{
    overflow-y: auto;
    height: 100%;
}

.pl-5 {
    padding-left: 5px;
}
.bg-white {
    background: white;
}
.personal {
    padding: 20px;
}
.mb-10 {
    margin-bottom: 10px;
}
.pt-10 {
    padding-top: 10px;
}
.pr-10 {
    padding-right: 10px;
}
.spinner {
    margin-top: 10px;
}
.text-description{
    word-break: break-word;
    text-align: start;
    color: #777a7d;
    font-weight: 600;
}
.text{
    color: #909399;
    font-size: 14px;
}
.label{
    text-align: left;
    padding-left: 20px;
}
</style>
